import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert,
  Checkbox,
  Tooltip
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import DatePicker from "react-date-picker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import CKEditor from "react-ckeditor-component";
import { bindActionCreators, compose } from "redux";
import "../../style/banners/AddBanners.scss";
import {
  updateBanners,
  getBannersDetails,
  getSiteList
} from "../../redux/actions/bannersActions";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../components";
import isEmpty from "lodash.isempty";
import loader from "../../style/loader/loader.scss";
import Picky from "react-picky";

const history = createHashHistory();

class EditBanners extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bannersID: "",
      title: "",
      banner_image: '',
      banner_image_link: '',
      start_date: "",
      end_date: "",
      status: "active",
      displaySubadmin: 0,
      displayMerchant: 0,
      siteList: [],
      selectedSites: [],
      path: ["Home", "Banners", "Edit Banners"],
      links: ["home","banners","EditBanners"],
      alertMessage: "",
      msgType: "",
      show: false,
      isLoading: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSiteChange = this.handleSiteChange.bind(this);
  }

  onChangeStartDate = date => { this.setState({ start_date: date, startDateTimeError:""})};
  onChangeEndDate = date => { this.setState({ end_date: date, endDateTimeError:""})};

  handleSiteChange(event, data) {
    this.setState({
      selectedSites: event
    });
  }  

  componentWillMount(e) {
    let bannersIdParams = this.props.match.params.bannersId
    ? this.props.match.params.bannersId
    : "";
    if (bannersIdParams !== "") {
      const editLink = `EditBanners/${bannersIdParams}`
      this.props.getBannersDetails(bannersIdParams);
      this.state.path = ["Home", "Banners", "Edit Banners"];
      this.state.links = ["home","banners",editLink];
    }
    this.props.getSiteList({page: 0});
  }

  componentWillUnmount() {
    this.setState({ alertMessage: "", msgType: "", show: false });
  }

  componentWillReceiveProps(nextProps) {

    if (this.props.fetchBanners !== nextProps.fetchBanners) {
      this.setState({ isLoading: nextProps.fetchBanners });
    }

    if(this.props.siteList !== nextProps.siteList){
      if(nextProps.siteList){
        this.setState({
          sitedata: nextProps.siteList,
          siteList: nextProps.siteList
        })
      }
    } 

    if (
      this.props.bannersDetails !== nextProps.bannersDetails &&
      !isEmpty(nextProps.bannersDetails)
      ) {
      this.setState({ bannersDetailsForEdit: nextProps.bannersDetails.data });
      let bannersDetails = nextProps.bannersDetails.data;
      this.setState({
        bannersID: bannersDetails.bannersID,
        title: bannersDetails.title,
        banner_org_image: bannersDetails.banner_image,
        banner_image_link: bannersDetails.banner_image_link,
        start_date: (bannersDetails.start_date) ? new Date(moment(bannersDetails.start_date).format('YYYY-MM-DD')) : "",
        end_date: (bannersDetails.end_date) ? new Date(moment(bannersDetails.end_date).format('YYYY-MM-DD')) : "",
        status: bannersDetails.status,
        displaySubadmin: bannersDetails.displaySubadmin,
        displayMerchant: bannersDetails.displayMerchant,
        siteID: bannersDetails.siteID,
        selectedSites: bannersDetails.siteListID
      });
    }
    if (this.props.error !== nextProps.error) {
      this.setState({
        alertMessage: nextProps.error,
        msgType: "warning",
        show: true
      });
    }
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    if (e.target.name === "start_date" || e.target.name === "end_date") {
      this.setState({ endDateTimeError: "", startDateTimeError: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  displaySubadmin = e => {
    if (e.target.checked) {
      this.setState({displaySubadmin: 1 });
    } else {
      this.setState({ displaySubadmin: 0 });
    }
  };

  displayMerchant = e => {
    if (e.target.checked) {
      this.setState({displayMerchant: 1 });
    } else {
      this.setState({ displayMerchant: 0 });
    }
  };

  handleValidation() {
    let formIsValid = true;
    this.state.titleError = false;
    this.state.bannerImageError = false;
    this.state.startDateTimeError = false;
    this.state.endDateTimeError = false;
    this.state.banner_image_linkError = false;
    if (!this.state.title) {
      formIsValid = false;
      this.setState({
        titleError: "Title Field is Required !"
      });
    }
    if (!this.state.banner_image_link) {
      formIsValid = false;
      this.setState({
        banner_image_linkError: "Banner Image Link Field is Required !"
      });
    }
    if (!this.state.banner_org_image) {
      formIsValid = false;
      this.setState({
        bannerImageError: "Banner Image Field is Required !"
      });
    }
    if (!this.state.start_date) {
      formIsValid = false;
      this.setState({
        startDateTimeError: "Start Date Field is Required !"
      });
    }
    if (!this.state.end_date) {
      formIsValid = false;
      this.setState({
        endDateTimeError: "End Date Field is Required !"
      });
    }
    return formIsValid;
  }

  handleSubmit(e) {
    e.preventDefault();
    let seletedIDs = this.state.selectedSites.map((sVal, index) => sVal.siteID);
    if (this.handleValidation()) {
        const formData = new FormData();
        formData.append("bannersID", this.state.bannersID);
        formData.append("title", this.state.title);
        formData.append("banner_image", (this.state.banner_image) ? this.state.banner_image : '');
        formData.append("banner_image_link", (this.state.banner_image_link) ? this.state.banner_image_link : '');
        formData.append("start_date", this.state.start_date? moment(this.state.start_date).format("YYYY-MM-DD")
          : null);
        formData.append("end_date", this.state.end_date? moment(this.state.end_date).format("YYYY-MM-DD")
          : null);
        formData.append("status", this.state.status);
        formData.append("displaySubadmin", this.state.displaySubadmin);
        formData.append("displayMerchant", this.state.displayMerchant);
        formData.append("siteID", seletedIDs);
        this.props.updateBanners(formData);
    }
  }

  getValidationSDateState() {
    const sDate = moment(this.state.start_date).format("YYYY-MM-DD");
    const eDate = moment(this.state.end_date).format("YYYY-MM-DD");
    if (this.state.start_date && this.state.start_date) {
      if (sDate > eDate) return "error";
    }
    if (!this.state.start_date && this.state.end_date) return "error";

    return null;
  }

  getValidationEDateState() {
    const sDate = moment(this.state.start_date).format("YYYY-MM-DD");
    const eDate = moment(this.state.end_date).format("YYYY-MM-DD");
    if (this.state.end_date && this.state.start_date) {
      if (eDate < sDate) return "error";
    }
    if (!this.state.end_date && this.state.start_date) return "error";

    return null;
  }

  onStartDateTimeBlur = e => {
    e.preventDefault();
    const startDate = moment(this.state.start_date).format("YYYY-MM-DD");
    const endDate = moment(this.state.end_date).format("YYYY-MM-DD");
    if (this.state.endDateTime && this.state.start_date) {
      if (startDate > endDate) {
        this.setState({
          startDateTimeError: "Start date should be less than end date!"
        });
      }else{
        this.setState({
          startDateTimeError: ""
        });
      }
    }
  };
  onEndDateTimeBlur = e => {
    e.preventDefault();
    const startDate = moment(this.state.start_date).format("YYYY-MM-DD");
    const endDate = moment(this.state.end_date).format("YYYY-MM-DD");
    if (this.state.start_date && this.state.end_date) {
      if (startDate > endDate) {
        this.setState({
          endDateTimeError: "End date should be greater than start date!"
        });
      }else{
       this.setState({
        endDateTimeError: ""
      });
     }
   }
 };

  handleselectedFile = event => {
    this.setState({
      banner_image: event.target.files[0],
      bannerImageError: ""
    })
    let file = event.target.files[0];
    if (file) {
      this.setState({
        banner_org_image: URL.createObjectURL(file)
      });
    }
  }


  render() {
 
    let pageTitle = "Edit Banners";
    let siteListData = this.state.siteList
      ? this.state.siteList
      : [];

    const { siteList, selectedSites } = this.state;
    let siteNamefromID = this.state.selectedSites.map((sVal, index) => sVal.siteName);  

    return (
      <div className="col-lg-12 add-banners">
        <BreadcrumbComponent path={this.state.path} links={this.state.links}/>

        <div className="panel">
          <header className="panel-heading">{pageTitle}</header>
          <div className="panel-body">
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong className="alert-msg-type">
                      {this.state.msgType}:
                    </strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <div className="add-banners col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <form onSubmit={this.handleSubmit}>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formBasicTitle">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span>Title
                      </ControlLabel>
                      <FormControl
                        type="text"
                        name="title"
                        value={this.state.title}
                        placeholder="Enter text"
                        onChange={this.handleChange}
                      />
                      {this.state.titleError && (
                        <Tooltip
                        placement="bottom"
                        className="in"
                        id="tooltip-bottom"
                        >
                        {this.state.titleError}
                        </Tooltip>
                        )}
                    </FormGroup>
                    <FormGroup controlId="formBannerImage">
                      <ControlLabel>Banner Image</ControlLabel>
                      <FormControl 
                        type="file" 
                        name="banner_image" 
                        onChange={this.handleselectedFile} 
                        >
                      </FormControl>
                      <span className="text-danger" style={{ fontSize: '12px', textTransform: 'none' }}>(Valid image formats JPG and PNG)</span><br />
                      {this.state.bannerImageError && (
                        <Tooltip
                        placement="bottom"
                        className="in"
                        id="tooltip-bottom"
                        >
                        {this.state.bannerImageError}
                        </Tooltip>
                        )}
                      <span>
                      <img
                      src={this.state.banner_org_image}
                      style={{ width: "100px", maxHeight: "80px" }}
                      />
                      </span>
                    </FormGroup>
                    <FormGroup controlId="formBannerImageLink">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span>Banner Image Link
                      </ControlLabel>
                      <FormControl
                        type="text"
                        name="banner_image_link"
                        value={this.state.banner_image_link}
                        placeholder="Enter Banner Image Link"
                        onChange={this.handleChange}
                      />
                      {this.state.banner_image_linkError && (
                        <Tooltip
                        placement="bottom"
                        className="in"
                        id="tooltip-bottom"
                        >
                        {this.state.banner_image_linkError}
                        </Tooltip>
                        )}
                    </FormGroup>
                    <FormGroup
                        controlId="formStartDateTime"
                        validationState={this.getValidationSDateState()}
                        onBlur={this.onStartDateTimeBlur.bind(this)}
                        >
                        <ControlLabel><span style={{color: "red"}}>*</span> Start Date:</ControlLabel><br/>
                        <DatePicker            
                          onChange={this.onChangeStartDate} 
                          value={(this.state.start_date) ? this.state.start_date : "" }                                                  
                        />
                        {this.state.startDateTimeError && (
                          <Tooltip
                            placement="bottom"
                            className="in"
                            id="tooltip-bottom"
                          >
                            {this.state.startDateTimeError}
                          </Tooltip>
                        )}
                    </FormGroup>

                    <FormGroup
                        controlId="formEndDateTime"
                        validationState={this.getValidationEDateState()}
                        onBlur={this.onEndDateTimeBlur.bind(this)}
                        >
                        <ControlLabel><span style={{color: "red"}}>*</span> End Date:</ControlLabel><br/>
                        <DatePicker            
                          onChange={this.onChangeEndDate} 
                          value={(this.state.end_date) ? this.state.end_date : "" }                                                  
                        />
                        {this.state.endDateTimeError && (
                          <Tooltip
                            placement="bottom"
                            className="in"
                            id="tooltip-bottom"
                          >
                            {this.state.endDateTimeError}
                          </Tooltip>
                        )}            
                    </FormGroup>
                    <FormGroup controlId="formStatus">
                      <ControlLabel>Status</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="status"
                        onChange={this.handleChange}
                        value={this.state.status}
                      >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formSiteID">
                      <ControlLabel>Choose which site(s) the banners</ControlLabel>     
                      <Picky
                        numberDisplayed={3}
                        options={siteList}
                        value={selectedSites}
                        valueKey="siteID"
                        labelKey="siteName"
                        multiple={true}
                        includeSelectAll={true}
                        includeFilter={true}
                        onChange={this.handleSiteChange}
                        dropdownHeight={200}
                      />
                    </FormGroup>             
                    <FormGroup controlId="formDisplaySubadmin"> 
                      <ControlLabel>Display Banners option</ControlLabel>  
                      {(this.state.displaySubadmin == 1) ?             
                        <Checkbox
                          name="displaySubadmin"
                          defaultChecked={true}
                          key={Math.random()}
                          onChange={this.displaySubadmin}
                        >
                          Display in Subadmin Accounts
                        </Checkbox> 
                      :
                        <Checkbox
                          name="displaySubadmin"
                          key={Math.random()}
                          onChange={this.displaySubadmin}
                        >
                          Display in Subadmin Accounts
                        </Checkbox>
                      }
                    </FormGroup>
                    <FormGroup controlId="formDisplayMerchant">  
                      {(this.state.displayMerchant == 1) ?
                        <Checkbox
                          name="displayMerchant"
                          key={Math.random()}
                          defaultChecked={true}
                          onChange={this.displayMerchant}
                        >
                        Display in Merchant Portal
                        </Checkbox> 
                      :
                        <Checkbox
                          name="displayMerchant"
                          key={Math.random()}
                          onChange={this.displayMerchant}
                        >
                        Display in Merchant Portal
                        </Checkbox>  
                      }  
                   </FormGroup>                                     
                  </Col>
                  <Col md={6} xs={12}>
                    {this.state.isLoading ? (
                      <div className="loader">
                        <p className="loading-message">
                          <i>Loading...</i>
                        </p>
                        <div className="spinner">
                          <div className="dot1" />
                          <div className="dot2" />
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                  </Col>
                  <Col md={12} xs={12}>
                    <Button
                      bsStyle="primary"
                      disabled={this.props.sendingBannersData}
                      type="submit"
                    >
                      Submit
                    </Button>
                    <Button
                      bsStyle="default"
                      onClick={() => history.push(`/banners`)}
                    >
                      Cancel
                    </Button>
                  </Col>
                </form>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

EditBanners.propTypes = {
  updateBanners: PropTypes.func.isRequired
};

const mapStateToProps = state => ({ 
  bannersDetails: state.bannersReducers.bannersDetails,
  error: state.bannersReducers.error,
  fetchBanners: state.bannersReducers.fetchBanners,
  sendingBannersData: state.bannersReducers.sendingBannersData,
  bannersResponse: state.bannersReducers.bannersResponse,
  siteList: state.bannersReducers.siteList,
  bannersUpdate: state.bannersReducers.bannersUpdate
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    getBannersDetails,
    getSiteList,
    updateBanners
  })
)(EditBanners);



// WEBPACK FOOTER //
// ./src/app/views/banners/EditBanners.js